import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fill",
  "use": "icon-fill-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-fill\"><path fill=\"#242526\" stroke=\"#242526\" d=\"M.5.5h13v13H.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol